Vue.component('admin-events', {
  template: templates.adminEvents,
  data() {
    return {
      model: {
          edit: false,
          isTournamentEnabled: false,
          isQuestEnabled: false,
          isCustomEnabled: true,
          loginSelected: false,
          hasData: false,
          expandedRow: '',
          event:{
            keyEnabled: false,
            keys_amount: 0,
            keyId: null,
            tierkey: false,
            keyTier: 0,
            selectedUser: null,
            selectedUsers: [],
            userTier: null,
            levelOption: null,
            level: 0,
            name: null,
            description: null,
            from: null,
            to: null,
            tournament: null,
            quest:null,
            loginCount:0,
            loginStreak: false,
            custom: {
              battleOption: '',  
              card_amount: 0, 
              wins: 0,
              attempt: 0,
              level: 0,
              retry: 0,
              cards:[{ cardId: null, tier: 0 }],
              temporaryCards: [],
              selectedMode: '',
              cardTeam: false,
              cardManagementMode: 'existing',
              teamName: ''
            },
            tournamentId: null,
            questId: null,
            rewards: {
              xp: 0,
              barks: 0,
              givePack: [{ packId: null, packs_quantity: 0 }],
              randomCard: [{ randomCard: 0, random_amount: 0 }],
              rewardFrames: [],
              rewardFrameMode: 'single-frame',
              packs_amount: 0,
              random_amount: 0,
            }
          },
          keys:{},
          quests: {},
          battle_options: [
            { value: 'single', name: 'Single Battle' },
            { value: '2v2', name: '2v2' },
            { value: '3v3', name: '3v3' },
            { value: '4v4', name: '4v4' }
          ],
          userOptions: [
            { value: 'all', name: 'All Users' },
            { value: 'streamers', name: 'Streamers Only' },
            { value: 'specificuser', name: 'Specific User' },
          ],
          userTiers: [
            { value: '0', name: 'All' },
            { value: '1', name: 'Prime Plus' },
            { value: '2', name: 'Ultra Plus' },
            { value: '3', name: 'Legendary Plus' },
          ],
          levelOptions: [
            { value: 'all', name: 'All Levels' },
            { value: '>', name: '>' },
            { value: '<', name: '<' },
            { value: '>=', name: '>=' },
            { value: '<=', name: '<=' },
            { value: '=', name: '=' },
          ],
          players: [
            { value: '4', name: '4' },
            { value: '8', name: '8' },
            { value: '16', name: '16' },
            { value: '32', name: '32' },
            { value: '64', name: '64' },
            { value: '128', name: '128' },
          ],
          option: [
            { name: '' },
            { name: 'Standard Cards Only' },
            { name: 'Ultra Cards Only' },
            { name: 'Legendary Cards Only' },
            { name: 'Ultimate Cards Only' },
            { name: 'Ultra Cards or less' },  
            { name: 'Legendary Cards or Less' },  
            { name: 'No Ultimates' },  
            { name: 'No Augmentation/Delta' },  
            { name: 'No Limits' } 
          ],
          expandedRow: '',
          cards: {},
          eventCards: {},
          exoticCards: {},
          activeEventCards: [],
          types: {},
          abilities: {},
          traits: [],
          events: [],
          selectedQuest: {},
          randomcard: [
            {
              name: '-- Select Card Type --'
            },
            {
              name: 'Standard Card'
            },
            {
              name: 'Ultra Card'
            },
            {
              name: 'Legendary Card'
            },
            {
              name: 'Ultimate Card'
            },
            {
              name: 'Bone Card'
            },  
            {
              name: 'Ascension Card'
            } 
          ],
          packs: {},
          frames: {},
          backgrounds: {},
          cardBacks: {},
          tournaments: {},
          existingTournament: false,
          existingQuest: false
      }
    }
  },
  computed: {
    filteredUserTiers() {
        const c = this;
        return c.model.userTiers.filter(userTier => userTier.value !== '0' && userTier.value !== '1');
    }
  },
  mounted() {
    const c = this;
    c.get();
    c.getCards();
    c.getAbilities();
    c.getTypes();
    c.getTraits();
    c.getPack();
    c.getFrames();
    c.getBackgrounds();
    c.getCardBacks();
    c.getEventCards();
    c.getActiveEventCards();
    c.connect();
    c.loadCustom();
    c.getKey();
    c.getExoticCards();
  },
  methods: {
      connect() {
        const c = this;
        c.ws = new WebSocket(utils.getWsUrl());
  
        c.ws.onmessage = (event) => {
  
          const messageData = event.data;
  
          try {
  
            const parsedData = JSON.parse(messageData);
            // if(parsedData.twitchId === utils.cookies.get('user_id') && parsedData.twitchId === 'barks'){
            //   c.get();
            // }
           
  
          } catch (error) {
            console.error('Error parsing message data:', error);
          }
        
        };
  
        c.ws.onopen = () => {
          console.log('WebSocket connection established');
        };
  
        c.ws.onclose = () => {
          console.log('WebSocket connection closed');
        };
      },
      searchStreamers() {
        const c = this;
        let names = [];
        const twitchDisplayName = $('[name="unlock-user"]').val();

        userService.searchStreamers({ twitchDisplayName: twitchDisplayName })
          .then(function (response) {
            c.model.searchResults = response.data;
  
            // Create a mapping of display names to connection IDs
            const userMap = {};
            for (let data of response.data) {
              names.push(data.twitchDisplayName);
              userMap[data.twitchDisplayName] = data.connectionId; // Map display name to connection ID
            }
  
            // Initialize autocomplete
            $('[name="unlock-user"]').autocomplete({
              source: names,
              select: function (event, ui) {
                const selectedDisplayName = ui.item.value;
                const connectionId = userMap[selectedDisplayName]; // Get the connection ID
                
                
                if (!c.model.event.selectedUsers.includes(selectedDisplayName)) {
                  c.model.event.selectedUsers.push(selectedDisplayName);
                }
                console.log("Selected Users:", c.model.event.selectedUsers);
              }
            });
          })
          .catch(function (error) {
            console.error("Error fetching users:", error);
          });
      },
      add() {
          const c = this;
          c.model.edit = true;

      },
      get() {
        const c = this;
        let data = {};
        eventsService.get()
        .then(function (response) {

          for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.events = data;
       
  
        })
        .catch(function (response){
          // console.log(response)
        })
       console.log(c.model)
      },
      getCards() {
        const c = this;
        let data = {};

        cardService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.cards = data;
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      getExoticCards() {
        const c = this;
        let data = {};
        exoticCardService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.exoticCards = data;
          })
          .catch(function () {});
      },
      getEventCards() {
        const c = this;
        let data = {};

        cardService.getEventCards()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.eventCards = data;
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      getActiveEventCards() {
        const c = this;

        cardService.getActiveEventCards()
          .then(function (response) {
            console.log(response)
            c.model.activeEventCards = response.data;
          })
          .catch(function (error) {
            //console.log(error);
          });
          
      },
      getTypes() {
        const c = this;
        let data = {};
  
        typeService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.types = data;
            // c.$root.$emit('types', data);
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      getAbilities() {
        const c = this;
        let data = {};

        abilityService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.abilities = data;
            // c.$root.$emit('abilities', data);
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      getTraits() {
        const c = this;

        traitService.get()
          .then(function (response) {
            c.model.traits = response.data;
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      selectedReward(){
        const c = this;
  
        if(c.model.event.reward === 1){
          c.getPack();
          c.model.event.xp = null;
          c.model.event.othersReward = {
            others: null,
            randomCard: null,
            random_amount: null,
            barks: null
          }

        }
        else if(c.model.event.reward === 0){

          c.model.packs = null;
          c.model.event.givePack = {
            packId: null,
            packs_quantity: null,
          }
          c.model.event.othersReward = {
            others: null,
            randomCard: null,
            random_amount: null,
            barks: null,
          }

        }
        else{

          c.model.event.givePack = {
            packId: null,
            packs_quantity: null,
          }

          c.model.event.xp = null;
          c.model.packs = null;
        }
      },
      othersSelected(){
        const c= this;
        if(c.model.event.othersReward.others === 0){

          c.model.event.othersReward.randomCard = null
          c.model.event.othersReward.random_amount = null;
          c.model.event.othersReward.barks = null;
          
        }
        else if(c.model.event.othersReward.others === 1){
          c.model.event.othersReward.barks = null;
        }
        else{
          c.model.event.othersReward.randomCard = null;
          c.model.event.othersReward.random_amount = null
        }
      },
      randomSelected(){
        const c= this;
        console.log(c.model)
      },
      save(){
        const c = this;

        const data = c.model.event;

        if (!data.name) {
          utils.alert.error('Event name is required');
          return;
        }

        if (!data.description) {
          utils.alert.error('Event Description is required');
          return;
        }

        if (!data.from) {
          utils.alert.error('Date From is required');
          return;
        }

        if (!data.to) {
          utils.alert.error('Date To is required');
          return;
        }

        if(!data.selectedUser){
          utils.alert.error('Select Users cannot be empty');
          return;
        }

        if(c.model.event.selectedUser == 'all'){

          if(!data.userTier){
            utils.alert.error('Select tier');
            return;
          }

          if(data.levelOption != 'all' || data.levelOption == null){
            if(data.level == 0){
              utils.alert.error('Level must not be empty');
              return;
            }
          }

        }

        if(data.selectedUser == 'specificuser'){
          if(data.selectedUsers.length == 0){
            utils.alert.error('users cannot be empty');
            return;
          }
        }

        if(c.model.existingTournament){
          if(data.tournamentId == null){
            utils.alert.error('Select Tournament');
            return;
          }
        }

        if(Number(data.rewards.xp) === 0 && Number(data.rewards.barks) === 0 && data.rewards.givePack[0].packId === null && Number(data.rewards.givePack[0].packs_quantity) === 0 && Number(data.rewards.randomCard[0].randomCard) === 0 && Number(data.rewards.randomCard[0].random_amount) === 0){
          utils.alert.error('Give atleast 1 reward');
          return;
        }

        if(c.model.isCustomEnabled){

          if (!data.custom.cardManagementMode) {
            data.custom.cardManagementMode = 'existing';
          }

          if(data.custom.cardTeam){
            if(!data.custom.teamName){
              utils.alert.error('Team Name Required!');
              return;
            }
        
            if(c.model.event.custom.cardManagementMode === 'existing'){
              for(i=0;i<data.custom.cards.length;i++){
  
                if(data.custom.cards[i].cardId === null){
                  utils.alert.error('Select a card');
                  return;
                }
              
                if(data.custom.cards[i].tier < 1){
                  utils.alert.error('Card tier must be greater than 1');
                  return;
                }
      
              }

              if(data.custom.card_amount === 0){
                utils.alert.error('Select Atleast 1 Card');
                return;
              }

            }
            else{
              for(i=0;i<data.custom.temporaryCards.length;i++){
  
                if(data.custom.temporaryCards[i].name === ""){
                  utils.alert.error('Card Name Required');
                  return;
                }
  
                if(data.custom.temporaryCards[i].hp <= 0){
                  utils.alert.error('Card HP Required');
                  return;
                }
  
                if(data.custom.temporaryCards[i].pAtk <= 0){
                  utils.alert.error('Card Physical Attack Required');
                  return;
                }

                if(data.custom.temporaryCards[i].mAtk <= 0){
                  utils.alert.error('Card Magic Attack Required');
                  return;
                }

                if(data.custom.temporaryCards[i].armor <= 0){
                  utils.alert.error('Card Armor Required');
                  return;
                }

                if(data.custom.temporaryCards[i].ward <= 0){
                  utils.alert.error('Card Ward Required');
                  return;
                }
  
                if(data.custom.temporaryCards[i].speed <= 0){
                  utils.alert.error('Card Speed Required');
                  return;
                }
  
                if(data.custom.temporaryCards[i].accuracy <= 0){
                  utils.alert.error('Card Accuracy Required');
                  return;
                }
  
                if(data.custom.temporaryCards[i].type <= 0){
                  utils.alert.error('Card Type Required');
                  return;
                }
  
                if(data.custom.temporaryCards[i].ability <= 0){
                  utils.alert.error('Card Ability Required');
                  return;
                }
              
                if(data.custom.temporaryCards[i].tier < 1){
                  utils.alert.error('Card tier must be greater than 1');
                  return;
                }
      
              }
            }
         
          }


          if(data.custom.battleOption == ''){
           
            utils.alert.error('Select Battle Options');
            return;
          }

          if(data.custom.wins === 0){
            utils.alert.error('wins is required');
            return;
          }

          if(c.model.event.custom.cardManagementMode === 'existing'){
            for(i=0;i<data.custom.cards.length;i++){
  
              if(data.custom.cards[i].cardId === null){
                utils.alert.error('Select a card');
                return;
              }
            
              if(data.custom.cards[i].tier < 1){
                utils.alert.error('Card tier must be greater than 1');
                return;
              }
    
            }
          }
          

          if(!data.custom.selectedMode){
            utils.alert.error('Select Mode');
            return;
          }

        }

        if(c.model.isTournamentEnabled){
          if(!c.model.existingTournament){
            const validationErrors = c.validateTournament(data.tournament);
            if (validationErrors.length > 0) {
                validationErrors.forEach(error => utils.alert.error(error));
                return;
            }
          }
        }

        if(c.model.isQuestEnabled){
          if(!c.model.existingQuest){
            c.validateQuest(c.model.event.quest);
          }
        }

        if(c.model.loginSelected){
          if(c.model.event.loginCount === 0){
            utils.alert.error('Login days count must be greater than 0');
            return;
          }
        }
          console.log(data)

        eventsService.save(data)
        .then(function (response) {
          const eventId = response.data?.id || data.id;

          // Save reward frames/backgrounds if any are selected
          if (data.rewards.rewardFrames && data.rewards.rewardFrames.length > 0) {
            c.saveEventRewardFrames(eventId, data.rewards.rewardFrames);
          }

          // c.reset();
          c.get();
          // const messageData = {
          //   status: 'event',
          // };

          // c.ws.send(JSON.stringify(messageData));
          utils.alert.success('Saved!');

        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });
  
    
      },
      edit(id) {
        const c = this;
        let data = c.model.events[`${id}`];
        let packs;
     
        if (id == c.model.events.id) {
          c.model.edit = false;
        } else {
          c.model.edit = true;
        }

        if(data.tournament){
          c.model.isTournamentEnabled = true;     
          c.model.existingQuest = false 
          c.model.isQuestEnabled = false;
          c.model.isCustomEnabled = false

          c.model.hasData = true
        }  
        if(data.quest){
          c.model.isTournamentEnabled = false;
          c.model.existingTournament = false
          c.model.isQuestEnabled = true;
          c.model.isCustomEnabled = false

          c.model.hasData = true
        }
        if(data.custom){
          c.model.isTournamentEnabled = false;
          c.model.isQuestEnabled = false;
          c.model.isCustomEnabled = true

          c.model.hasData = true
          console.log(data)
          if(!data.custom.cards){
            data.custom.cards =[{ cardId: null, tier: 0 }]
          }
        }

        if(data.loginCount > 0){
          c.model.hasData = false
          c.model.isCustomEnabled = false
          c.model.loginSelected = true;
        }

        c.model.event = {
          keyEnabled: data.keyEnabled,
          keys_amount: data.keys_amount,
          keyId: data.keyId,
          tierKey: data.tierKey,
          keyTier: data.keyTier,
          id: data.id,
          selectedUser: data.selectedUser,
          selectedUsers: data.selectedUsers || [],
          userTier: data.userTier,
          levelOption: data.levelOption,
          level: data.level,
          name: data.name,
          description: data.description,
          from: data.from,
          to: data.to,
          loginCount: data.loginCount,
          loginStreak: data.loginStreak,
          tournament: data.tournament,
          quest:data.quest,
          custom: data.custom,
          tournamentId: data.tournamentId,
          questId: data.questId,
          rewards: data.rewards
        }

        // Initialize rewardFrames if not exists
        if (!c.model.event.rewards.rewardFrames) {
          c.model.event.rewards.rewardFrames = [];
        }
        if (!c.model.event.rewards.rewardFrameMode) {
          c.model.event.rewards.rewardFrameMode = 'single-frame';
        }

      // c.model.cards.splice(0, data.cards.length, ...data.cards);

        // Load linked reward frames/backgrounds from adminRewardFrames
        c.loadEventRewardFrames(id);
      },
      reset(){
        const c = this;
        c.model.edit = false;
        c.model.event = {
          keyEnabled: false,
          keys_amount: 0,
          keyId: null,
          tierkey: false,
          keyTier: 0,
          selectedUser: null,
          selectedUsers: [],
          userTier: null,
          levelOption: null,
          level: 0,
          name: null,
          description: null,
          from: null,
          to: null,
          tournament: null,
          loginCount: 0,
          loginStreak: false,
          quest:null,
          custom: {
            battleOption: '',  
            card_amount: 0, 
            wins: 0,
            attempt: 0,
            level: 0,
            retry: 0,
            cards:[{ cardId: null, tier: 0 }],
            temporaryCards: [],
            selectedMode: '',
            cardTeam: false,
            cardManagementMode : 'existing',
            teamName: ''
          },
          tournamentId: null,
          questId: null,
          rewards: {
            xp: 0,
            barks: 0,
            givePack: [{ packId: null, packs_quantity: 0 }],
            randomCard: [{ randomCard: 0, random_amount: 0 }],
            rewardFrames: [],
            rewardFrameMode: 'single-frame',
            packs_amount: 0,
            random_amount: 0,
          }
        }
        c.model.isTournamentEnabled = false
        c.model.hasData = false
      },
      loginstreak(){
        const c = this;
      },
      getPack(){
        const c = this;
        let data = {};

        packService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.packs = data;
          })
          .catch(function (error) {
            //console.log(error);
          });
      },

      getFrames(){
        const c = this;
        let data = {};

        frameService.get()
          .then(function (response) {
            for (let d of response.data) {
              d.frameImage = d.uploaded && d.extension
                ? `${root}/images/frames/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
                : null;
              data[`${d.id}`] = d;
            }
            c.model.frames = data;
          })
          .catch(function (error) {
            console.error('Error loading frames:', error);
          });
      },

      getBackgrounds(){
        const c = this;
        let data = {};

        backgroundService.get()
          .then(function (response) {
            for (let d of response.data) {
              d.backgroundImage = d.extension
                ? `${root}/images/backgrounds/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
                : null;
              data[`${d.id}`] = d;
            }
            c.model.backgrounds = data;
          })
          .catch(function (error) {
            console.error('Error loading backgrounds:', error);
          });
      },

      getCardBacks(){
        const c = this;
        let data = {};

        cardBackService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.cardBacks = data;
          })
          .catch(function (error) {
            console.error('Error loading card backs:', error);
          });
      },

      loadEventRewardFrames(eventId){
        const c = this;

        // Load all reward frames, then filter by event_id (events may have empty reward_type)
        rewardFrameService.get({})
          .then(function (response) {
            if (!response.success) {
              console.error('Failed to load reward frames');
              return;
            }

            // Get all frames and filter by event_id
            let allFrames = [];
            if (response.data.event) {
              allFrames = response.data.event;
            } else if (Array.isArray(response.data)) {
              allFrames = response.data;
            } else if (typeof response.data === 'object') {
              // Flatten all grouped data
              allFrames = Object.values(response.data).flat();
            }

            const linkedFrames = allFrames.filter(r => r.event_id == eventId);
            const frameRewards = linkedFrames.map(r => ({ id: r.frame_id, type: 'frame' }));

            // Load all reward backgrounds
            return rewardBackgroundService.get({})
              .then(function (bgResponse) {
                if (!bgResponse.success) {
                  console.error('Failed to load reward backgrounds');
                  return;
                }

                // Get all backgrounds and filter by event_id
                let allBackgrounds = [];
                if (bgResponse.data.event) {
                  allBackgrounds = bgResponse.data.event;
                } else if (Array.isArray(bgResponse.data)) {
                  allBackgrounds = bgResponse.data;
                } else if (typeof bgResponse.data === 'object') {
                  allBackgrounds = Object.values(bgResponse.data).flat();
                }

                const linkedBackgrounds = allBackgrounds.filter(r => r.event_id == eventId);
                const backgroundRewards = linkedBackgrounds.map(r => ({ id: r.background_id, type: 'background' }));

                // Combine both and update the event rewards
                const combinedRewards = [...frameRewards, ...backgroundRewards];

                if (combinedRewards.length > 0) {
                  // Determine mode based on count and types
                  let mode = 'single-frame';
                  if (combinedRewards.length === 1) {
                    mode = combinedRewards[0].type === 'frame' ? 'single-frame' : 'single-background';
                  } else {
                    mode = 'multiple';
                  }

                  // Update the entire rewards object to ensure reactivity
                  const updatedRewards = {
                    ...c.model.event.rewards,
                    rewardFrames: combinedRewards,
                    rewardFrameMode: mode
                  };

                  // Replace the entire rewards object to trigger Vue reactivity
                  Vue.set(c.model.event, 'rewards', updatedRewards);

                  console.log('Set event reward frames to:', c.model.event.rewards.rewardFrames);
                  console.log('Set mode to:', mode);
                } else {
                  console.log('No linked frames/backgrounds found for event');
                }
              });
          })
          .catch(function (error) {
            console.error('Error loading event reward frames/backgrounds:', error);
          });
      },

      saveEventRewardFrames(eventId, rewardFrames){
        console.log('Saving reward frames for event:', eventId, rewardFrames);

        // First, load existing frames/backgrounds to delete them
        Promise.all([
          rewardFrameService.get({}),
          rewardBackgroundService.get({})
        ]).then(function([frameResponse, bgResponse]) {
          console.log('Fetched existing frames:', frameResponse);
          console.log('Fetched existing backgrounds:', bgResponse);

          // Find existing frames/backgrounds for this event (check all groups)
          let allFrames = [];
          let allBackgrounds = [];

          if (frameResponse.data.event) {
            allFrames = frameResponse.data.event;
          } else if (Array.isArray(frameResponse.data)) {
            allFrames = frameResponse.data;
          } else if (typeof frameResponse.data === 'object') {
            allFrames = Object.values(frameResponse.data).flat();
          }

          if (bgResponse.data.event) {
            allBackgrounds = bgResponse.data.event;
          } else if (Array.isArray(bgResponse.data)) {
            allBackgrounds = bgResponse.data;
          } else if (typeof bgResponse.data === 'object') {
            allBackgrounds = Object.values(bgResponse.data).flat();
          }

          const existingFrames = allFrames.filter(r => r.event_id == eventId);
          const existingBackgrounds = allBackgrounds.filter(r => r.event_id == eventId);

          console.log('Existing frames for this event:', existingFrames);
          console.log('Existing backgrounds for this event:', existingBackgrounds);

          // Delete existing frames
          const deletePromises = [];
          existingFrames.forEach(frame => {
            console.log('Deleting event frame:', frame.id);
            deletePromises.push(
              rewardFrameService.delete(frame.id)
                .then(res => console.log('Deleted event frame:', frame.id, res))
                .catch(err => console.error('Error deleting event frame:', frame.id, err))
            );
          });
          existingBackgrounds.forEach(bg => {
            console.log('Deleting event background:', bg.id);
            deletePromises.push(
              rewardBackgroundService.delete(bg.id)
                .then(res => console.log('Deleted event background:', bg.id, res))
                .catch(err => console.error('Error deleting event background:', bg.id, err))
            );
          });

          return Promise.all(deletePromises);
        }).then(function() {
          // Separate frames and backgrounds
          const frames = rewardFrames.filter(r => r.type === 'frame');
          const backgrounds = rewardFrames.filter(r => r.type === 'background');

          // Save each frame
          const savePromises = [];
          frames.forEach(frame => {
            const frameData = {
              frame_id: frame.id,
              event_id: eventId,
              reward_type: 'event',  // Changed to 'event' to match API validation
              unlock_type: 'frame',
              is_active: true,
              is_guaranteed: true
            };

            savePromises.push(
              rewardFrameService.save(frameData)
                .then(function(response) {
                  console.log('Saved reward frame:', response);
                })
                .catch(function(error) {
                  console.error('Error saving reward frame:', error);
                })
            );
          });

          // Save each background
          backgrounds.forEach(background => {
            const backgroundData = {
              background_id: background.id,
              event_id: eventId,
              reward_type: 'event',  // Changed to 'event' to match API validation
              is_active: true,
              is_guaranteed: true
            };

            savePromises.push(
              rewardBackgroundService.save(backgroundData)
                .then(function(response) {
                  console.log('Saved reward background:', response);
                })
                .catch(function(error) {
                  console.error('Error saving reward background:', error);
                })
            );
          });

          return Promise.all(savePromises);
        }).then(function() {
          console.log('All event reward frames/backgrounds saved successfully');
        }).catch(function(error) {
          console.error('Error in saveEventRewardFrames:', error);
        });
      },

      selectedCards(number){
        const c = this;

        console.log(number)
      },
      formattedDate(eventDate) {
        const date = new Date(eventDate);
        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      },
      toggleDetails(index) {
 
        const c = this;

        c.model.expandedRow = c.model.expandedRow === index ? null : index;

      },
      generateCards() {
        this.model.event.custom.cards = Array.from({ length: this.model.event.custom.card_amount }, (_, index) => ({
          cardId: null,
          tier: 0,
        }));
      },
      incrementPack(){
        const c = this;
        c.model.event.packs_amount++
        c.model.event.givePack.push({ packId: null, packs_quantity: 0 });
      },
      incrementCards(){
        const c = this;
        c.model.event.custom.card_amount++
        c.model.event.custom.cards.push({ cardId: null, tier: 0 });
        console.log(c.model.event)
      },
      incrementRandomCards(){
        const c = this;
        c.model.event.random_amount++
        c.model.event.randomCard.push({ randomCard: 0, random_amount: 0 });
      },
      removePack(index) {
        if (this.model.event.packs_amount > 0) {
          this.model.event.packs_amount--;
          this.model.event.givePack.splice(index, 1);
        }
      },
      removeCard(index){
        if (this.model.event.custom.card_amount > 0) {
          this.model.event.custom.card_amount--;
          this.model.event.custom.cards.splice(index, 1);
        }
      },
      removeRandomCard(index){
        if (this.model.event.random_amount > 0) {
          this.model.event.random_amount--;
          this.model.event.randomCard.splice(index, 1);
        }
      },
      selectedBattleOptions(){
        const c = this;
        console.log(c.model)
      },
      selectUsers(){
        const c = this;

        console.log('asdasd');

        if(c.model.event.selectedUser === 'specificuser'){
          c.model.event.userTier = null; 
          c.model.event.levelOption =null
          c.model.event.level = 0;
        }
        else{
          c.model.selectedUsers = []
        }

        if(c.model.event.selectedUser != 'all'){
          c.model.event.userTier = null;
        }
      },
      removeSelectedUser(index){
        const c = this;

        c.model.event.selectedUsers.splice(index, 1);
      },
      tournamentEnabled(){
        const c = this;

        let data = {};  
        if(c.model.existingTournament){

          c.model.existingQuest = false
          c.model.event.quest = null
          c.model.tournament = {}

          tournamentService.get()
          .then(function (response) {
  
              for (let d of response.data) {
                  data[`${d.id}`] = d;
              }
              c.model.tournaments = data;
              c.model.event.tournament = null
              
          })
          .catch(function (error) {
            c.model.isLoading = true
            utils.alert.error('error.');
          });
        }
        else{
          c.model.tournaments = {}
          c.model.event.tournamentId = null
        }

      },
      questEnabled(){
        const c = this;

        let data = {};  
        if(c.model.existingQuest){
          c.model.existingTournament = false
          questLineService.get()
          .then(function (response) {

            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.quests = data;
            c.model.event.quest = null;
    
          })
          .catch(function (response){
            // console.log(response)
          })
       
        }
        else{
          c.model.quests = {}
          c.model.event.questId = null
          c.loadQuest()
        }

      },
      levelRequired(){
        const c = this;
        if(c.model.event.levelOption == 'all'){
          c.model.event.level = 0
        }
   
      },
      inputValue(event){
        const c = this;

        if(event === 'tournament'){
          c.model.isTournamentEnabled = true;     
          c.model.existingQuest = false 
          c.model.isQuestEnabled = false;
          c.model.isCustomEnabled = false
          c.resetCustom();
          c.resetQuest()
          c.model.hasData = true
          

          c.model.event.tournament = {
            active: false,
            name: null,
            description: null,
            players: null,
            selectedOption: '',
            battleOption: '',
            autobattle: false,
            multipleBattle: false,
            faction: false,
            innerFaction: false,
            universalFaction: false
          }

        }
        else if(event === 'quest'){
          c.model.isTournamentEnabled = false;
          c.model.existingTournament = false
          c.model.isQuestEnabled = true;
          c.model.isCustomEnabled = false
          c.model.hasData = true
          c.resetCustom();
          c.resetTournament();

          c.loadQuest()
          
        }
        else{
          c.model.isTournamentEnabled = false;
          c.model.isQuestEnabled = false;
          c.model.isCustomEnabled = true
          c.model.hasData = false

          c.loadCustom();
          c.resetQuest()
          c.resetTournament();
        }

      },
      updateTaskData(updatedData, taskIndex, eventIndex) {
        const c = this;
        const data = this.model.events[eventIndex];
        if (data.task && data.task[taskIndex]) {
          data.task[taskIndex].task = updatedData.task; // Update task name
          data.task[taskIndex].rewards = updatedData.rewards; // Update rewards
        }
      },
      handleRewardChange(rewardData) {
        const c = this;
        c.model.event.rewards = { ...c.model.event.rewards, ...rewardData };
      },
      handleQuestChange(data) {
        const c = this;
        // Handle nested quest object properly
        if (data.model) {
            // Deep merge to preserve existing properties
            Object.keys(data.model).forEach(key => {
                if (Array.isArray(data.model[key])) {
                    c.model.event.quest[key] = [...data.model[key]];
                } else if (typeof data.model[key] === 'object' && data.model[key] !== null) {
                    c.model.event.quest[key] = { ...c.model.event.quest[key], ...data.model[key] };
                } else {
                    c.model.event.quest[key] = data.model[key];
                }
            });
        } else {
            // Handle direct property updates
            Object.keys(data).forEach(key => {
                if (Array.isArray(data[key])) {
                    c.model.event.quest[key] = [...data[key]];
                } else if (typeof data[key] === 'object' && data[key] !== null) {
                    c.model.event.quest[key] = { ...c.model.event.quest[key], ...data[key] };
                } else {
                    c.model.event.quest[key] = data[key];
                }
            });
        }
      },
      handleInputChange(updatedModel) {
        const c = this
        // Handle the input change from TournamentForm
        if (updatedModel && updatedModel.tournament) {
            c.model.event.tournament = { ...c.model.event.tournament, ...updatedModel.tournament };
        }
      },
      resetCustom(){
        const c = this;

        c.model.event.custom = null

      },
      resetTournament(){
        const c = this;
        c.model.event.tournament = null
        c.model.event.tournamentId = null
      },
      resetQuest(){
        const c = this;
        c.model.event.quest = null
        c.model.event.questId = null
      },
      loadQuest(){
        const c = this
        c.model.event.quest = {
          name: null,
          description: null,
          cards:[{ cardId: null, tier: 0 }],
          date: null,
          time: null,
          level: 0,
          card_amount: 0,
          selectedMode: null,
          wins: 0,
        }
      }, 
      validateQuest(data){
        if (!data.name) {
          utils.alert.error('Quest name is required');
          return;
        }

        if (!data.description) {
          utils.alert.error('Quest Rule is required');
          return;
        }

        for(i=0;i<data.cards.length;i++){

          console.log(data)

          if(data.cards[i].cardId === null){
            utils.alert.error('Select a card');
            return;
          }
        
          if(data.cards[i].tier < 1){
            utils.alert.error('Card tier must be greater than 1');
            return;
          }

        }

        if (!data.date) {
          utils.alert.error('Date is required');
          return;
        }

        if (!data.time) {
          utils.alert.error('Time is required');
          return;
        }
        
        if (!data.selectedMode) {
          utils.alert.error('select mode');
          return;
        }

        if (data.wins === 0) {
          utils.alert.error('wins must be greater than 1');
          return;
        }
      },
      validateTournament(data) {
        const c = this

        const errors = [];
        
        if (!data.name || data.name.trim() === '') {
            errors.push('Tournament name is required');
        }
        
        if (!data.description || data.description.trim() === '') {
            errors.push('Tournament description is required');
        }
        
        if (!data.players) {
            errors.push('Number of players is required');
        }
        
        if (!data.selectedOption) {
            errors.push('Tournament rules option is required');
        }
        
        if (!data.battleOption) {
            errors.push('Battle option is required');
        }
        
        return errors;
      },
      updateCard() {
        const c = this;
        c.model.event.custom.card_amount = c.model.event.custom.card_amount || 1;
      },
      loadCustom(){
        const c = this;
        
        c.model.event.custom = {
          battleOption: '',  
          card_amount: 0, 
          wins: 0,
          attempt: 0,
          level: 0,
          retry: 0,
          cards:[{ cardId: null, tier: 0 }],
          temporaryCards: [],
          selectedMode: '',
          cardTeam: false
        }

      },
      getEventType(event) {
        if (event.custom) {
            return 'Custom';
        } else if (event.quest) {
            return 'Quest';
        } else if (event.tournament) {
            return 'Tournament';
        }
        else{
          return 'Daily Login';
        }
        return null;
      },
      formattedDate(questDate) {
        const date = new Date(questDate);
        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      },
      battleRules(rules){
        if (rules === 'to_defeat') {
          return 'To Defeat';
        } else if (rules === 'to_win') {
          return 'To Win';
        } else if (rules === 'both'){
          return 'Win/Defeat';
        }
        else{
          return 'Battle';
        }
        return null;
      },
      addTaskToEvent(event, index) {
        const c = this;
        let data = c.model.events[index];
      
        // Initialize task array if it doesn't exist
        if (!data.task) {
          c.$set(data, 'task', []);
        }
      
        // Define limit based on event type
        let limit;
        if (data.custom) {

          limit = event.custom.wins;
          
        } else if (data.tournament) {

          limit = event.tournament.round;

        } else if (data.quest) {

          limit = event.quest.wins;

        } else {

          limit = event.loginCount;

        }
      
        if (limit && data.task.length >= limit) {
          utils.alert.error('Task limit reached');
          return;
        }

        const uniqueId = `task-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

        data.task.push({ 
          id: uniqueId, 
          task: null, 
          rewards: {} 
        });
      
      },
      loginSelected(){
        const c = this

        c.model.isCustomEnabled = false
        c.model.event.custom = null

        if(!c.model.loginSelected){
          c.model.isCustomEnabled = true
          c.loadCustom();
        }
      },
      async enableKey(){
        const c = this;

        if (c.model.event.keyEnabled) {
          await c.getKey();
        } else {
          
            c.model.event.keyId = '';
            c.model.event.keys_amount = 0;
        }

      },
      selectedKey(key){
        console.log(c.model)
      },
      getTotalTaskCount(event) {
        const taskCount = event.task?.length || 0;
        
        const totalLimit = event.custom?.wins || 
                          event.quest?.wins || 
                          event.tournament?.round || 
                          event.loginCount || 0;
        
        return `${taskCount}/${totalLimit}`;
      },
      updateTask(taskData, taskIndex, eventIndex) {
        const c = this;
        let data = c.model.events[eventIndex];
        if (data.task && data.task[taskIndex]) {
          data.task[taskIndex] = taskData;
        }
        c.get();
      },
      removeTask(taskIndex, eventIndex) {
        const c = this;
    
        let data = c.model.events[eventIndex];

        const taskData = data.task[taskIndex];

        eventsService.deleteTask(taskData)
        .then(function (response) {      

          console.log(response)
        })
        .catch(function (error) {
          utils.alert.error('Failed to save.');
        });

        if (data.task && data.task[taskIndex]) {
          data.task.splice(taskIndex, 1); 
          // c.$delete(data.task[taskIndex],taskIndex)
          c.$set(c.model.events[eventIndex], 'task', [...data.task]);
        }
     
      },
      saveTask(index, taskIndex){
        const c = this
        console.log('save')
      },
      generateTaskKey(index, taskIndex) {
        return `task-${index}-${taskIndex}`;
      },
      reorderTasks(data) {
        const c = this;
        const { fromIndex, toIndex, eventIndex } = data;
        const event = c.model.events[eventIndex];
        
        if (!event || !event.task) return;
        
        const tasks = [...event.task];
        
        // Remove the task from the old position and insert at new position
        const [movedTask] = tasks.splice(fromIndex, 1);
        tasks.splice(toIndex, 0, movedTask);
        
        // Update task indices
        tasks.forEach((task, index) => {
          task.taskIndex = index;
        });
        
        // Update the event's task array
        event.task = tasks;

        
        // Save the new order to database

        c.saveTaskOrder(event.id, tasks);
      },
      
      saveTaskOrder(eventId, tasks) {
        const c = this;
        const orderData = {
          eventId: eventId,
          tasks: tasks.map((task, index) => ({
            id: task.id,
            taskIndex: index,
            taskName: task.taskName,
            rewards: task.rewards
          }))
        };
        
        eventsService.updateTaskOrder(orderData)
          .then(function (response) {
            console.log('Task order updated successfully');
            utils.alert.success('Task order updated!');
          })
          .catch(function (error) {
            console.error('Failed to update task order:', error);
            utils.alert.error('Failed to update task order.');
            // Revert changes on error
            c.get();
          });
      },
      async getKey(){
        const c = this;
        let data = {};
    
        keyService.get()
          .then(function (response) {
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.keys = data;
          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      selectCustomTier(key){
        const c = this;
        console.log(key)
      },
      keyTier(tier){
        if(tier === 2){
          return 'Prime Tier';
        }
        else if(tier === 2){
          return 'Ultra Tier';
        }
        else{
          return 'Legendary Tier';
        }
      },
      handleCardModeChange(mode) {
        this.model.event.custom.cardManagementMode = mode;
        
        if (mode === 'existing') {
          // Clear temporary cards when switching to existing
          this.model.event.custom.temporaryCards = [];
        } else {
          // Clear existing cards when switching to temporary
          this.model.event.custom.cards = [{ cardId: null, tier: 0 }];
        }
      },
      
      handleExistingCardsUpdate(cards) {
        this.model.event.custom.cards = cards;
        this.model.event.custom.card_amount = cards.length;
      },
      
      handleTemporaryCardsUpdate(temporaryCards) {
        this.model.event.custom.temporaryCards = temporaryCards;
      },
      
      handleCardSelection(data) {
        // Handle when a card is selected from existing cards
        console.log('Card selected:', data);
      },
      generateCardTeam(event){
          const c = this;

          c.model.isTeam = event;

      }
  }
});